import React, { useState } from "react";
import Cases from "../../../components/cases";
import { useOutletContext } from "react-router-dom";
import MarkedCasesList from "../../../components/cases/MarkedCasesList";

const MarkedCases = () => {
  const [refresh, setRefresh] = useState(false);
  const [
    data,
    handleRefreh,
    location,
    search,
    handleSearch,
    searchFilterState,
    handleFilterStateActive,
    entireCasesText,
    handleEntireCasesText,
    handleSetConsultantFilter,
    selectedConsultant,
    consultantsList,
    selectedConsultantName,
  ] = useOutletContext();
  const handleRefreshByParent = () => {
    setRefresh((pre) => !pre);
    handleRefreh();
  };
  return (
    <MarkedCasesList
      data={data}
      handleRefresh={handleRefreshByParent}
      search={search}
      handleSearch={handleSearch}
      searchFilterState={searchFilterState}
      handleFilterStateActive={handleFilterStateActive}
      handleEntireCasesText={handleEntireCasesText}
      entireCasesText={entireCasesText}
      handleSetConsultantFilter={handleSetConsultantFilter}
      selectedConsultant={selectedConsultant}
      consultantsList={consultantsList}
      selectedConsultantName={selectedConsultantName}
    />
  );
};

export default MarkedCases;
